import { FOLLOW_UP_FIELD_LABELS } from "../model/materielConstants";
import { displayMergeValue } from "../model/followUpRules";
import {
    fieldLabelStyle,
    importIssuesStyle,
    importReportStyle,
    inputStyle,
    mergeChoiceStyle,
    mergeConflictFieldStyle,
    modalOverlayStyle,
    modalStyle,
    primaryButtonStyle,
    secondaryButtonStyle,
} from "../styles/materielStyles";

export function FollowUpMergeConflictModal({ conflict, saving, onChoice, onCancel, onConfirm }) {
    return (
        <div role="presentation" style={{ ...modalOverlayStyle, zIndex: 1100 }} onMouseDown={onCancel}>
            <div role="dialog" aria-modal="true" aria-labelledby="follow-up-merge-title" style={{ ...modalStyle, width: "min(760px, 100%)", maxHeight: "calc(100vh - 40px)", overflow: "auto" }} onMouseDown={event => event.stopPropagation()}>
                <div>
                    <h2 id="follow-up-merge-title" style={{ margin: 0, fontSize: "18px", color: "#111827" }}>Modifications concurrentes</h2>
                    <p style={{ margin: "6px 0 0", color: "#64748b", fontSize: "13px", lineHeight: 1.5 }}>
                        Un autre utilisateur a modifié les mêmes champs. Choisissez la valeur à conserver.
                    </p>
                </div>
                <div style={{ display: "grid", gap: "12px" }}>
                    {conflict.conflicts.map(field => (
                        <fieldset key={field} style={mergeConflictFieldStyle}>
                            <legend style={{ padding: "0 6px", color: "#334155", fontSize: "12px", fontWeight: 800 }}>
                                {FOLLOW_UP_FIELD_LABELS[field] || field}
                            </legend>
                            <label style={mergeChoiceStyle(conflict.choices[field] === "mine")}>
                                <input type="radio" name={`follow-up-merge-${field}`} checked={conflict.choices[field] === "mine"} onChange={() => onChoice(field, "mine")} />
                                <span><strong>Conserver ma valeur</strong><br />{displayMergeValue(conflict.local[field])}</span>
                            </label>
                            <label style={mergeChoiceStyle(conflict.choices[field] === "other")}>
                                <input type="radio" name={`follow-up-merge-${field}`} checked={conflict.choices[field] === "other"} onChange={() => onChoice(field, "other")} />
                                <span><strong>Conserver l'autre valeur</strong><br />{displayMergeValue(conflict.remote[field])}</span>
                            </label>
                        </fieldset>
                    ))}
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                    <button type="button" onClick={onCancel} disabled={saving} style={secondaryButtonStyle}>Annuler</button>
                    <button type="button" onClick={onConfirm} disabled={saving} style={primaryButtonStyle}>
                        {saving ? "Enregistrement..." : "Enregistrer les choix"}
                    </button>
                </div>
            </div>
        </div>
    );
}

export function MedicalEquipmentImportModal({
    file,
    report,
    importing,
    onFileChange,
    onCheck,
    onImport,
    onClose,
}) {
    return (
        <div role="presentation" style={modalOverlayStyle} onMouseDown={onClose}>
            <div role="dialog" aria-modal="true" aria-labelledby="medical-import-title" style={{ ...modalStyle, width: "min(680px, 100%)" }} onMouseDown={event => event.stopPropagation()}>
                <div>
                    <h2 id="medical-import-title" style={{ margin: 0, fontSize: "18px", color: "#111827" }}>Importer le suivi matériel médical</h2>
                    <p style={{ margin: "6px 0 0", color: "#64748b", fontSize: "13px", lineHeight: 1.5 }}>
                        Le fichier est traité par la plateforme. Le rapport ne reprend aucune identité patient.
                    </p>
                </div>
                <label style={fieldLabelStyle}>
                    Fichier Excel
                    <input
                        type="file"
                        accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
                        onChange={event => onFileChange(event.target.files?.[0] || null)}
                        style={inputStyle}
                    />
                </label>
                {report && (
                    <div role="status" style={importReportStyle}>
                        <strong>{report.dryRun ? "Contrôle terminé" : "Import terminé"}</strong>
                        <span>
                            Matériel : {report.dryRun ? report.rowsReady : report.rowsImported} ligne(s).
                            Contacts : {report.dryRun ? report.contactsReady : report.contactsImported} ligne(s).
                        </span>
                        {report.rowsSkipped > 0 && <span>{report.rowsSkipped} doublon(s) ignoré(s).</span>}
                        {report.issues?.length > 0 && (
                            <ul style={importIssuesStyle}>
                                {report.issues.slice(0, 12).map((issue, index) => (
                                    <li key={`${issue.sheet}-${issue.row}-${index}`}>
                                        {issue.sheet || "Classeur"}
                                        {issue.row > 0 ? `, ligne ${issue.row}` : ""} : {issue.message}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                )}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", flexWrap: "wrap" }}>
                    <button type="button" onClick={onClose} disabled={importing} style={secondaryButtonStyle}>Fermer</button>
                    <button type="button" onClick={onCheck} disabled={!file || importing} style={secondaryButtonStyle}>
                        {importing ? "Traitement..." : "Contrôler"}
                    </button>
                    <button type="button" onClick={onImport} disabled={!file || importing || (report?.dryRun && report.rowsReady + report.contactsReady === 0)} style={primaryButtonStyle}>
                        {importing ? "Import..." : "Importer"}
                    </button>
                </div>
            </div>
        </div>
    );
}
